import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useLocation } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { yupResolver } from "@hookform/resolvers/yup";
import "./CreateContact.css";
import FormHandler from "../../Common/Form/FormHandler/FormHandler";
import { toast } from "react-toastify";
import Loader from "react-spinner-loader";
import {
  agencyListURL,
  findContactsById,
  createJobTitle,
  regionListURL,
  skillListURL,
  getJobTitle,
  agencyTypeListURL,
  hierarchylevelListURL,
  getContacts,
  getThemeURL,
  getallbranchnames,
  getallBanksByRole,
} from "../../../../Services/EndPoints";
import {
  contactformschema,
  ContactFormConfig,
} from "../../../../JsonData/ContactConfig";
import {
  postDataWithBody,
  getData,
  putDataWithBody,
} from "../../../../Services/Services";
import ModalResourceType from "../../../../Components/UiComponents/ModalResourceType/ModalResourceType";
import { createContact, updateContact } from "../../../../Services/EndPoints";
import { useTranslation } from "react-i18next";

//Component for creating and editing contact details
const ContactRegistrationForm = (props) => {
  const { t } = useTranslation();
  const [contactDataById, setContactDataById] = useState({});
  const [regionDataFrUpsert, setRegionDataFrUpsert] = useState([]);
  const [regionChanged, isRegionChanged] = useState(false);
  const [jobTitleList, setJobTitleList] = useState({});
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [jobPopUp, setJobPopUp] = useState(false);
  const [loader, setLoader] = useState(true); // Start with loader active
  const [regionData, setRegionData] = useState([]);
  const [initialDataLoaded, setInitialDataLoaded] = useState(false); // Track if initial data is loaded
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(0);
  const { state } = useLocation();
  let dataFrEdit = state?.data;
  let edit = state?.edit;
  const location = useLocation();
  const { isContactFieldDisable } = location.state || {};
  const [componentKey, setComponentKey] = useState(0);

  useEffect(() => {
    // Initialize all data loading
    const loadAllData = async () => {
      setLoader(true);
      try {
        await Promise.all([
          getRegionList(),
          getUserProfile(),
          getAgencyTypeList(),
          getHierarchyLevelList(),
        ]);

        // After all initial data is loaded
        setInitialDataLoaded(true);
      } catch (error) {
        console.error("Error loading initial data:", error);
        toast.error("Failed to load required data. Please try again.");
      } finally {
        setLoader(false);
      }
    };

    loadAllData();
  }, []);

  //User profile call for role based bank list
  const getUserProfile = async () => {
    try {
      const userProfile = await getData(getThemeURL);
      if (userProfile && userProfile.length > 0) {
        fetchBanks(userProfile[0]);
      }
    } catch (error) {
      console.error("Error fetching user profile:", error);
      toast.error("Failed to fetch user profile", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    }
  };

  //Payload for role based bank list Api call
  const createPayload = (profile) => {
    let admin_role = "U"; // default value

    if (profile.role_name === "HO") {
      admin_role = "HO";
    } else if (profile.role_name === "SUPER ADMIN") {
      admin_role = "SA";
    }

    return {
      admin_role: admin_role,
      bank_id: profile.bank_id || null,
      branch_id: profile.branch_id || null,
    };
  };

  // Fetch bank details based on user role
  const fetchBanks = async (profile) => {
    try {
      const payload = createPayload(profile);
      const response = await postDataWithBody(getallBanksByRole, payload, {});
      if (response && Array.isArray(response)) {
        const formattedBanks = response.map((bank) => ({
          value: bank.id,
          label: bank.bankName,
        }));

        // Update the ContactFormConfig with the bank list - index 4 is where bank field is located
        ContactFormConfig[0].fields[4]["options"] = formattedBanks;
      } else {
        toast.error("Failed to load banks data");
        console.error("Invalid banks data:", response);
      }
    } catch (error) {
      toast.error("Failed to fetch banks");
      console.error("Fetch error:", error);
      throw error; // Re-throw to be caught by the Promise.all
    }
  };

  const getSkillData = async () => {
    try {
      var skillListArr = await getData(skillListURL);
      skillListArr.forEach(function (skill) {
        skill.label = skill.value;
        skill.value = skill.id;
      });
      // Update index 10 which is where skills field is located in the config
      ContactFormConfig[0].fields[10]["options"] = skillListArr;
    } catch (error) {
      toast.error("Failed to fetch skills");
      console.error("Skill fetch error:", error);
      throw error;
    }
  };

  // Then in the getRegionList function, use the modified function with max depth parameter
  const getRegionList = async () => {
    try {
      var regionList = await getData(regionListURL);
      regionList = regionList.map((region) => {
        if (region.name === "Bihar") {
          return { ...region, name: "All districts" };
        }
        return region;
      });
      setRegionData(regionList);

      // Specify maximum depth of 3
      let hierregionData = flatToHierarchy(regionList, "parent_region_id", 3);
      // Update index 7 which is where region field is located in the config
      ContactFormConfig[0].fields[7]["options"] = hierregionData[0];
      await getAllJobTitleList();
    } catch (error) {
      toast.error("Failed to fetch regions");
      console.error("Region fetch error:", error);
      throw error;
    }
  };

  const getAllJobTitleList = async () => {
    try {
      var jbTitlList = await getData(getJobTitle);
      let jbTitlTemp = [];
      jbTitlList.forEach((obj, index) => {
        jbTitlTemp.push({ label: obj.value, value: obj.id });
      });
      // Update index 8 which is where job title field is located in the config
      ContactFormConfig[0].fields[8]["options"] = jbTitlTemp;
      setJobTitleList(jbTitlTemp);
      await getAgencyList();
    } catch (error) {
      toast.error("Failed to fetch job titles");
      console.error("Job title fetch error:", error);
      throw error;
    }
  };

  // In the flatToHierarchy function, add a depth parameter to limit the hierarchy levels
  const flatToHierarchy = (flat, parent_key_name, maxDepth = 3) => {
    var roots = []; // things without parent
    var all = {};

    // First pass: collect all items
    flat.forEach(function (item) {
      all[item.id] = { ...item, depth: 1 }; // Add a depth property
    });

    // Second pass: build hierarchy
    Object.keys(all).forEach(function (id) {
      var item = all[id];
      item["id"] = item.id + "";
      item["label"] = item.name;
      item["value"] = item.id + "";

      if (item[parent_key_name] == 0) {
        roots.push(item);
      } else if (item[parent_key_name] in all) {
        var p = all[item[parent_key_name]];
        // Set child's depth
        item.depth = p.depth + 1;

        // Only add children if we haven't reached max depth
        if (item.depth <= maxDepth) {
          if (!("children" in p)) {
            p.children = [];
          }
          p.children.push(item);
        } else {
          // If beyond max depth, add to root level instead
          roots.push(item);
        }
      }
    });

    return roots;
  };

  const createJobTiltle = async (jobTitle) => {
    setLoader(true);
    try {
      let input = { job_title: jobTitle, status: true };
      var resourceData = await postDataWithBody(createJobTitle, input, {});
      let jbTitlTemp = [
        ...jobTitleList,
        { label: jobTitle, value: resourceData.id },
      ];
      // Update index 8 which is job title field
      ContactFormConfig[0].fields[8]["options"] = jbTitlTemp;
      setJobTitleList(jbTitlTemp);
    } catch (error) {
      toast.error("Failed to create job title");
      console.error("Job title creation error:", error);
    } finally {
      setLoader(false);
    }
  };

  const populateContactFormFrEdit = async (formdata, agencyList) => {
    setLoader(true);
    try {
      let contactdata = await postDataWithBody(
        findContactsById,
        [formdata?.id],
        {}
      );

      contactdata = contactdata[0];
      formdata["contact_type"] = contactdata["contact_type"];
      reset(formdata);
      setValue("contact_type", contactdata.contact_type);
      setContactDataById(contactdata);

      // Set agency value
      let agencyName = null;
      agencyList.forEach((agency) => {
        if (agency.value == contactdata.agency_id) {
          agencyName = agency.label;
        }
      });
      setValue("agency_id", contactdata.agency_id);

      // Set job title
      let jobTitle = null;
      let jobList = ContactFormConfig[0].fields[8]["options"];
      jobList.forEach((job) => {
        if (job.value == contactdata.job_title_id) {
          jobTitle = job.label;
        }
      });

      // Set bank and branch if available
      if (contactdata.bankId) {
        setValue("all_banks", contactdata.bankId);
        // This will trigger the useEffect to fetch branches
      }

      if (contactdata.branchId) {
        setValue("all_branches", contactdata.branchId);
      }

      // Handle skills if they exist
      if (
        contactdata.contact_skill_map &&
        contactdata.contact_skill_map.length > 0
      ) {
        const skillListDropArr =
          ContactFormConfig[0].fields[10]["options"] || [];
        let skillIdNameMap = {};
        skillListDropArr.forEach((skill) => {
          skillIdNameMap[skill.value] = skill.label;
        });

        let skillArr = [];
        contactdata.contact_skill_map.forEach((skill) => {
          skillArr.push({
            label: skillIdNameMap[skill.skill_id],
            value: skill.skill_id,
          });
        });
        setValue("skills", skillArr);
      }

      // Handle regions
      let slectedRegions = [];
      if (
        contactdata.contact_region_map &&
        contactdata.contact_region_map.length > 0
      ) {
        contactdata.contact_region_map.forEach((contact) => {
          slectedRegions.push(contact.region_id + "");
        });

        let regionDataTemp = ContactFormConfig[0].fields[7].options;
        let regionDataWthSlctdValus = addSelectedFlag(
          [regionDataTemp],
          slectedRegions
        );
        setRegionData(regionDataWthSlctdValus);
        ContactFormConfig[0].fields[7]["options"] = regionDataWthSlctdValus[0];
      }
    } catch (error) {
      toast.error("Failed to load contact details");
      console.error("Contact load error:", error);
    } finally {
      setLoader(false);
    }
  };

  function addSelectedFlag(data, selectedValues) {
    return data.map(({ type, children = [], ...rest }) => {
      const o = { ...rest, type };
      if (selectedValues.indexOf(o.id) > -1) {
        o.checked = true;
      }
      if (children.length)
        o.children = addSelectedFlag(children, selectedValues);
      return o;
    });
  }

  const onHierDropdownChange = (currentNode, selectedNodes) => {
    isRegionChanged(true);
    let regionDataSlected = selectedNodes.map((region) => ({
      region_id: region.id,
    }));

    setRegionDataFrUpsert(regionDataSlected);
    // Always update the field value
    setValue("region", selectedNodes, {
      shouldValidate: true,
      shouldDirty: true,
    });

    // Clear any existing validation error
    if (selectedNodes.length > 0) {
      clearErrors("region"); // This removes the error from React Hook Form state
    }
  };

  const getAgencyList = async () => {
    try {
      var agencyList = await getData(agencyListURL);
      for (let agency in agencyList) {
        agencyList[agency]["label"] = agencyList[agency]["name"];
        agencyList[agency]["value"] = agencyList[agency]["id"];
      }
      // Update index 6 which is agency field
      ContactFormConfig[0].fields[6]["options"] = agencyList;
      await getSkillData();

      if (dataFrEdit) {
        await populateContactFormFrEdit(dataFrEdit, agencyList);
      }
    } catch (error) {
      toast.error("Failed to fetch agencies");
      console.error("Agency fetch error:", error);
      throw error;
    }
  };

  const jobHandler = () => {
    setJobPopUp(!jobPopUp);
  };

  const handleAddJobTitle = async (jobTitle) => {
    await createJobTiltle(jobTitle);
    setJobPopUp(false);
  };

  function showSuccessMsg() {
    toast.success("Job title added successfully.", {
      position: toast.POSITION.TOP_CENTER,
      autoClose: 2000,
    });
  }

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    getValues,
    trigger,
    reset,
    control,
    clearErrors,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(contactformschema[activeTab]),
    mode: "all",
  });

  const selectedbankid = watch("all_banks");

  useEffect(() => {
    if (selectedbankid) {
      fetchBranchDetails();
    }
  }, [selectedbankid]);

  const fetchBranchDetails = async () => {
    setLoader(true);
    try {
      const response = await getData(
        getallbranchnames.replace("ID", selectedbankid)
      );
      if (response && Array.isArray(response)) {
        const formattedBranches = response.map((branch) => ({
          value: branch.id,
          label: branch.branchName,
        }));

        // Update index 5 which is branch field
        const updatedConfig = [...ContactFormConfig];
        updatedConfig[0].fields[5]["options"] = formattedBranches;
      } else {
        toast.error("Failed to load branch data");
        console.error("Invalid branch data:", response);
      }
    } catch (error) {
      toast.error("Failed to fetch branches");
      console.error("Fetch error:", error);
    } finally {
      setLoader(false);
    }
  };

  const GenerateForm = (fields, register, errors, control) => {
    return (
      <div>
        <FormHandler
          register={register}
          errors={errors}
          fields={fields}
          onChange={onHierDropdownChange}
          control={control}
          columns={2}
          getValues={getValues}
          isContactFieldDisable={isContactFieldDisable}
        />
      </div>
    );
  };

  const generateTabsData = (tabWiseData) => {
    tabWiseData?.forEach((element) => {
      return (element.component = GenerateForm(
        element?.fields,
        register,
        errors,
        control
      ));
    });
    return tabWiseData;
  };

  const submitHandler = async (data, e) => {
    const phone1 = data.phone1;
    setLoader(true);

    try {
      // Fetch contact list to check if phone1 exists
      const response = await getData(getContacts);

      const contactExists = response.some(
        (contact) =>
          contact.phone1 === phone1 &&
          (!dataFrEdit || contact.id !== dataFrEdit.id)
      );

      if (contactExists) {
        toast.error("Contact number already exists", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
        setLoader(false);
        return;
      }

      e.preventDefault();
      data["status"] = true;
      data["type"] = 1;
      data["contact_region_map"] = regionDataFrUpsert;

      // Transform bank and branch fields
      data.bankId = data.all_banks ? parseInt(data.all_banks) : null;
      data.branchId = data.all_branches ? parseInt(data.all_branches) : null;

      // Remove the original fields
      delete data.all_banks;
      delete data.all_branches;

      let res = null;
      if (dataFrEdit) {
        // Edit existing contact logic
        delete data["created_on"];
        delete data["updated_on"];
        data["id"] = dataFrEdit.id;

        // Update region data if it has changed
        if (dataFrEdit && !regionChanged) {
          // Use existing regions if not changed
          data["contact_region_map"] = contactDataById.contact_region_map;
        } else {
          // Use newly selected regions
          data["contact_region_map"] =
            regionDataFrUpsert.length > 0
              ? regionDataFrUpsert
              : data.region?.map((region) => ({ region_id: region.id }));
        }

        // Update contact
        res = await putDataWithBody(updateContact, data, {});
      } else {
        // Create new contact
        res = await postDataWithBody(createContact, data, {});
      }

      // Handle response
      if (res.status === "success") {
        toast.success(res.msg, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
        navigate("../view-contact");
      } else {
        toast.error(res.msg, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
      }
    } catch (error) {
      console.error("Error fetching contact list or submitting:", error);
      toast.error("An error occurred while processing your request", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    } finally {
      setLoader(false);
    }
  };

  async function getAgencyTypeList() {
    try {
      var agencyList = await getData(agencyTypeListURL);

      for (let agency in agencyList) {
        agencyList[agency]["label"] = agencyList[agency]["value"];
        agencyList[agency]["value"] = agencyList[agency]["id"];
      }
      // Update index 1 for agency type field
      ContactFormConfig[0].fields[1]["options"] = agencyList;
    } catch (error) {
      toast.error("Failed to fetch agency types");
      console.error("Agency type fetch error:", error);
      throw error;
    }
  }

  async function getHierarchyLevelList() {
    try {
      var hierarchyList = await getData(hierarchylevelListURL);

      for (let hierarchy in hierarchyList) {
        hierarchyList[hierarchy]["label"] = hierarchyList[hierarchy]["name"];
        hierarchyList[hierarchy]["value"] = hierarchyList[hierarchy]["id"];
      }
      // Update index 2 for hierarchy level field
      ContactFormConfig[0].fields[2]["options"] = hierarchyList;
    } catch (error) {
      toast.error("Failed to fetch hierarchy levels");
      console.error("Hierarchy level fetch error:", error);
      throw error;
    }
  }

  const saveTabDataHandler = async (e) => {
    const isStepValid = await trigger();
    if (isStepValid) setActiveTab((prevId) => prevId + 1);
  };
  useEffect(() => {
    if (initialDataLoaded && dataFrEdit && contactDataById.contact_region_map) {
      const regions = contactDataById.contact_region_map.map((r) =>
        r.region_id.toString()
      );
      setValue("region", regions, { shouldValidate: true });
    }
  }, [initialDataLoaded, dataFrEdit, contactDataById]);

  const previousHandler = () => {
    if (activeTab > 0) {
      setActiveTab((prevId) => prevId - 1);
    }
  };
  const handleCancelClick = () => {
    setShowCancelModal(true);
  };
  const handleConfirmCancel = () => {
    reset({
      bank_name: [],
    }); // This will reset the form fields to their default values
    setValue("all_branches", "");
    setShowCancelModal(false); // Close the modal
    setRegionDataFrUpsert([]); // Reset region-related state if needed
    setActiveTab(0);
    setComponentKey((prevKey) => prevKey + 1);
  };

  const tabsData = generateTabsData(ContactFormConfig);

  return (
    <div className="mt-4">
      <Loader
        show={loader}
        type="body"
        stack="vertical"
        message="Loading Data"
      />

      {/* Only render the form when initialDataLoaded is true and loader is false */}
      {initialDataLoaded && !loader && (
        <div className="form-body">
          <div className="registration__form--body">
            <form
              key={componentKey}
              onSubmit={handleSubmit(submitHandler)}
              name="CreateContactRegForm"
            >
              <div>
                {tabsData?.map((tabs) => (
                  <React.Fragment key={tabs.id}>
                    {tabs.id === activeTab && (
                      <>
                        <div className="registration__form--heading">
                          {tabs.heading}
                        </div>
                        <div>{tabs.component}</div>
                      </>
                    )}
                  </React.Fragment>
                ))}
              </div>
              <div
                className="form-submit-container full-width-field"
                style={{ marginTop: "50px" }}
              >
                {activeTab > 0 && (
                  <button
                    type="button"
                    className="branch-save-submit-btn btn btn-success"
                    onClick={previousHandler}
                    style={{
                      backgroundColor: "#1a7a73",
                      fontFamily: "Poppins",
                      fontSize: "14px",
                      marginRight: "10px",
                    }}
                  >
                    {t("previous")}
                  </button>
                )}

                {tabsData.length - 1 === activeTab ? (
                  <>
                    <button
                      type="submit"
                      className="branch-save-submit-btn btn btn-success"
                      disabled={loader}
                      style={{
                        backgroundColor: "#1a7a73",
                        fontFamily: "Poppins",
                        fontSize: "14px",
                        marginRight: "10px",
                      }}
                    >
                      {edit ? t("Update") : t("saveAndSubmit")}
                    </button>
                    {!edit && (
                      <button
                        type="button"
                        className="branch-save-submit-btn btn btn-success"
                        onClick={handleCancelClick}
                        style={{
                          backgroundColor: "#1a7a73",
                          fontFamily: "Poppins",
                          fontSize: "14px",
                        }}
                      >
                        Cancel
                      </button>
                    )}
                  </>
                ) : (
                  <button
                    type="button"
                    className="branch-save-submit-btn btn btn-success"
                    onClick={saveTabDataHandler}
                    style={{
                      backgroundColor: "#1a7a73",
                      fontFamily: "Poppins",
                      fontSize: "14px",
                    }}
                  >
                    {t("save&next")}
                  </button>
                )}
              </div>
            </form>
          </div>
        </div>
      )}

      {jobPopUp && (
        <ModalResourceType
          titleValue={t("popup.tittle")}
          showSuccessMsg={showSuccessMsg}
          onAddJobTitle={handleAddJobTitle}
          show={jobPopUp}
          buttonLabel={t("popup.button")}
          handleToggle={jobHandler}
          popupLabel={t("popup.label")}
          {...props}
        />
      )}
      <Modal
        show={showCancelModal}
        onHide={() => setShowCancelModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm </Modal.Title>
        </Modal.Header>
        <Modal.Body>Would you like to clear the input values?</Modal.Body>
        <Modal.Footer>
          <button
            className="btn"
            style={{
              backgroundColor: "lightgray",
              color: "#000",
              marginRight: "10px",
            }}
            onClick={() => setShowCancelModal(false)}
          >
            No
          </button>
          <button
            className="btn"
            style={{
              backgroundColor: "green",
              color: "#fff",
            }}
            onClick={handleConfirmCancel}
          >
            Yes
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ContactRegistrationForm;
